<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="город"
      :is-disabled="isDisabled"
      :state="state"
      :initial-value="value"
      :get-item-by-id="getTown"
      :get-list="getItems"
      :can-create-catalog="canEditTown()"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <town-catalog
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import TownCatalog from "./TownCatalog.vue";
    import CatalogSelect from "../CatalogSelect.vue";

export default {
  name: "TownSelect",
  components: { CatalogSelect, TownCatalog },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    state: { type: Boolean, default: null },
    value: { type: Number, default: null },
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getTowns({});
      return (result && result.data && result.data.items) ? result.data.items : [];
    },
    async getTown(id) {
      const result = await this.getTownById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canEditTown() {
      return this.hasPermission([PERM.CATALOG_TOWN_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Towns/TownSelect.vue